import React from "react";
import SpecializationFilter from "../FiltersRow/SpecializationFilter";
import DropdownFilter from "../Filter/DropdownFilter";

const ReviewsFilters = ({doctors, handleFilter}) => {
  return (
    <div className="filters filters-100 reviews-page__filters">
      {
        // <div className="reviews-page__filter">
        //   <SpecializationFilter />
        // </div>
      }
      <div className="filters-100 reviews-page__filter">
        <DropdownFilter
          name="time"
          getTitle={value => doctors.get(value)}
          title="Врач"
          values={doctors}
          defaultValue={0}
          onFilter={handleFilter}
        />
      </div>
    </div>
  )
};

export default ReviewsFilters;
